const LogisticManagementMasterItemsNewCustomUnit = async () =>
    import('../../pages/inventory/items/New').then((module) => ({
        Component: module.LogisticManagementMasterItemsNew,
    }));
const LogisticManagementMasterItemsEditCustomUnit = async () =>
    import('../../pages/inventory/items/Edit').then((module) => ({
        Component: module.LogisticManagementMasterItemsEdit,
    }));
const LogisticManagementMasterItemsListCustomUnit = async () =>
    import('../../pages/inventory/items/List').then((module) => ({
        Component: module.LogisticManagementMasterItemsList,
    }));
const LogisticManagementMasterItemsViewCustomUnit = async () =>
    import('../../pages/inventory/items/View').then((module) => ({
        Component: module.LogisticManagementMasterItemsView,
    }));

const getMasterItemRoutes = (user) => {
    if (user?.carrierId) return [];

    return [
        // Master items with Custom Unit
        {
            path: '/inventory/items/new',
            lazy: LogisticManagementMasterItemsNewCustomUnit,
        },
        {
            path: '/inventory/items/:masterItemId/edit',
            lazy: LogisticManagementMasterItemsEditCustomUnit,
        },
        {
            path: '/inventory/items/:masterItemId/',
            lazy: LogisticManagementMasterItemsViewCustomUnit,
        },
        {
            path: '/inventory/items/',
            lazy: LogisticManagementMasterItemsListCustomUnit,
        },
        {
            path: '/inventory/items/archived/',
            lazy: LogisticManagementMasterItemsListCustomUnit,
        },
        {
            path: '/inventory/items/unarchived/',
            lazy: LogisticManagementMasterItemsListCustomUnit,
        },
    ];
};

export { getMasterItemRoutes };
